export default class DtoLinksColumnPAR {
    constructor(object = {}) {
        this.idUsagerColumn = object.idUsagerColumn // Int
        this.idPointDePrelevementColumn = object.idPointDePrelevementColumn // Int
        this.idUsagePreviColumn = object.idUsagePreviColumn // Int
        this.volumeDemandeColumn = object.volumeDemandeColumn // Option[Int]
        this.volumeDemandeEtiageColumn = object.volumeDemandeEtiageColumn // Option[Int]
        this.volumeAttribueColumn = object.volumeAttribueColumn // Option[Int]
        this.volumeAttribueEtiageColumn = object.volumeAttribueEtiageColumn // Option[Int]
        this.commentaireAttributionColumn = object.commentaireAttributionColumn // Option[Int]
        this.volumeAutoriseColumn = object.volumeAutoriseColumn // Option[Int]
        this.volumeAutoriseEtiageColumn = object.volumeAutoriseEtiageColumn // Option[Int]
        this.commentaireAutorisationColumn = object.commentaireAutorisationColumn // Option[Int]
        this.debitAutorisationColumn = object.debitAutorisationColumn // Option[Int]
    }
}
